import "./registerShopSkeleton.css";

const SkeletonInput = () => <div className="skeleton-input shimmer" />;
const SkeletonButton = () => <div className="skeleton-button shimmer" />;

const RegisterPageSkeleton = () => {
	return (
		<div className="container">
			<div className="sf-registershop-container">
				<div className="card" style={{ maxWidth: 420, margin: "40px auto" }}>
					<div className="bd">
						<div className="sf-register-skeleton">
						<div className="skeleton-title shimmer" />

						{/* Email */}
						<SkeletonInput />

						{/* Name row */}
						<div className="skeleton-row">
							<SkeletonInput />
							<SkeletonInput />
						</div>

						{/* Phone */}
						<SkeletonInput />

						{/* Passwords */}
						<SkeletonInput />
						<SkeletonInput />

						{/* Referral */}
						<SkeletonInput />

						{/* Category */}
						<SkeletonInput />
						<SkeletonInput />

						{/* Terms */}
						<div className="skeleton-checkbox shimmer" />

						{/* Button */}
						<SkeletonButton />
					</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegisterPageSkeleton;